export default __webpack_public_path__ + "static/media/Search-Icon-White.29eea2c3.svg";